import { createFileRoute, Link } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { PageContent } from "@/components/common/page-content"
import { Button } from "@/components/ui/button"
import { IndividualIdentityDocuments } from "@/features/individuals/components/individual-identity-documents"
import { individualQueries } from "@/queries/individuals"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/individuals/$individualId/identity/"
)({
  staticData: { attention: "individual.identity" },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      individualQueries.identityDocuments(params.individualId)
    ),
  component: IndividualIdentityPage,
})

function IndividualIdentityPage() {
  const { individualId } = Route.useParams()
  return (
    <>
      <PageHeader
        title="Identity evidence"
        actions={
          <Button
            nativeButton={false}
            render={
              <Link
                from="/$organisation"
                to="/$organisation/individuals/$individualId/identity/edit"
                params={{ individualId }}
              >
                Add a document
              </Link>
            }
          />
        }
      />

      <PageContent>
        <IndividualIdentityDocuments individualId={individualId} />
      </PageContent>
    </>
  )
}
